module.exports = __webpack_public_path__ + "img/logo303.139f5bbb.png";